import React from 'react';
import {useLocation, useNavigate} from 'react-router-dom';
interface ButtonGroupsProps {
  isOpenOffer: boolean;
  isDeleteModalOpen: boolean;
  isOpenOfferPrepayment: boolean;
  is_saled: boolean;
  postType: string;
  guid: string;
  setIsOpenOfferAuction: (isOpenOffer: boolean) => void;
  setIsOpenOfferPrepayment: (isOpenOfferPrepayment: boolean) => void;
  setisDeleteModalOpen: (isDeleteModalOpen: boolean) => void;
}
const ButtonGroups = ({
  isOpenOffer,
  postType,
  isDeleteModalOpen,
  is_saled,
  guid,
  isOpenOfferPrepayment,
  setIsOpenOfferAuction,
  setIsOpenOfferPrepayment,
  setisDeleteModalOpen,
}: ButtonGroupsProps) => {
  const navigate = useNavigate();
  const location = useLocation();

  const isFarm = location.pathname.includes('farm');
  return (
    <div className="flex flex-col w-full items-start gap-8 text-gray-6 font-medium text-[16px]">
      {postType === 'auction' && (
        <button
          className="flex items-center gap-2"
          onClick={() => setIsOpenOfferAuction(!isOpenOffer)}
        >
          <span className={' text-primary icon-suggest-auction text-[26px]'} />
          <span className="text-[16px]"> مشاهده پیشنهادات</span>
        </button>
      )}
      {postType === 'prepayment' && !is_saled && (
        <button
          className="flex items-center gap-2"
          onClick={() => setIsOpenOfferPrepayment(!isOpenOfferPrepayment)}
        >
          <span
            className={' text-primary icon-presell-manage-ad text-[20px]'}
          />
          <span className="text-[16px]"> مشاهده پیشنهادات</span>
        </button>
      )}
      {!is_saled && (
        <button
          className="flex items-center gap-2"
          onClick={() =>
            navigate(`/${isFarm ? 'farm' : 'wholesaler'}/edit/info/${guid}`)
          }
        >
          <span className="icon-edit-my-ad text-primary" />
          <span className="text-[16px]">ویرایش آگهی</span>
        </button>
      )}
      {!is_saled && (
        <button className="flex items-center gap-2">
          <span className="icon-upgrade text-primary" />
          <span className="text-[16px]">ارتقا آگهی</span>
        </button>
      )}
      <button
        className="flex items-center gap-2"
        onClick={() => setisDeleteModalOpen(!isDeleteModalOpen)}
      >
        <span className="icon-trash text-error" />
        <span className="text-[16px]">حذف آگهی</span>
      </button>
    </div>
  );
};

export default ButtonGroups;
